<div class="p-4 bg-white rounded-lg shadow-lg w-full">
  <h4 class="font-semibold text-gray-800 mb-4 text-center">Select Date & Time</h4>

  <!-- Calendar -->
  <div class="flex justify-center">
    <mat-calendar [minDate]="data.minDate" [(selected)]="selectedDate" class="bg-gray-100 p-2 rounded-lg w-72"></mat-calendar>
  </div>

  <!-- Time Picker -->
  <div class="flex justify-center items-center mt-4 space-x-3">
    <!-- Hour -->
    <div class="flex flex-col items-center">
      <button (click)="increaseHour()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <input
        type="number"
        [(ngModel)]="hour"
        [min]="is12HourFormat ? 1 : 0"
        [max]="is12HourFormat ? 12 : 23"
        class="w-12 p-1 border rounded text-center text-lg font-semibold focus:ring focus:ring-blue-300"
      />
      <button (click)="decreaseHour()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>

    <span class="text-lg font-bold">:</span>

    <!-- Minute -->
    <div class="flex flex-col items-center">
      <button (click)="increaseMinute()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <input
        type="number"
        [(ngModel)]="minute"
        min="0" max="59"
        class="w-12 p-1 border rounded text-center text-lg font-semibold focus:ring focus:ring-blue-300"
      />
      <button (click)="decreaseMinute()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>

    <!-- AM/PM Toggle for 12-hour format only -->
    <div *ngIf="is12HourFormat" class="flex flex-col items-center">
      <button (click)="toggleAmPm()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <span class="w-12 p-1 border rounded text-center text-lg font-semibold focus:ring focus:ring-blue-300">
        {{ period }}
      </span>
      <button (click)="toggleAmPm()" class="text-gray-700 hover:text-blue-500 focus:outline-none border-0 bg-white cursor-pointer">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-end mt-6 space-x-2">
    <button mat-flat-button class="px-3 py-1 transition text-sm cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
    <button mat-flat-button color="primary" class="px-3 py-1 transition text-sm save-btn" (click)="confirmDateTime()">
      OK
    </button>
  </div>
</div>
